// Mint Week – läuft nur, wenn snippets/mint-week.liquid die Klasse `mint-week`
// gesetzt hat. Setzt das Aktions-Band über den Produktpreis und streut Konfetti:
// einmal pro Besuch beim Laden, optional bei „In den Warenkorb“.
(function () {
  if (!document.documentElement.classList.contains('mint-week')) return;

  var script = document.currentScript;

  // Aktions-Band über dem Produktpreis (assets/campaign-band.js), nicht bei Sets.
  // Öffentlich: Ersparnis aus dem Streichpreis. Ponyclub-Preparty: Code mit
  // Prozent-Ersparnis, Countdown bis Ende des Preparty-Tags.
  var info = window.pnyMintWeek || {};
  if (!info.excluded && window.pnyCampaignBand) {
    var early = info.phase === 'early';
    window.pnyCampaignBand({
      icon: '🩵',
      title: early ? 'Ponyclub Preparty' : 'Mint Week',
      endDay: info.end,
      savings: early ? 'percent' : 'compare',
      percent: info.percent,
      code: early ? info.code : '',
      colors: { bg: '#2f8478', pillBg: '#fff', pillFg: '#2f8478', muted: '#d9ebea', accent: '#fff' }
    });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var onLoad = script && script.dataset.onLoad === 'true';
  var onCart = script && script.dataset.onCart === 'true';
  var COLORS = ['#2f8478', '#92c1c4', '#1a3e40', '#e9917b', '#f09482', '#ffffff'];

  function burst(count, originY) {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = (canvas.width = window.innerWidth * dpr);
    var h = (canvas.height = window.innerHeight * dpr);

    var pieces = [];
    for (var i = 0; i < count; i++) {
      pieces.push({
        x: w * (0.1 + Math.random() * 0.8),
        y: originY === undefined ? -20 * dpr - Math.random() * h * 0.3 : h * originY,
        vx: (Math.random() - 0.5) * (originY === undefined ? 2 : 14) * dpr,
        vy: originY === undefined ? (2 + Math.random() * 3) * dpr : -(8 + Math.random() * 8) * dpr,
        size: (6 + Math.random() * 6) * dpr,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        round: Math.random() < 0.3,
      });
    }

    var startTime = performance.now();
    var DURATION = 3500;
    function frame(now) {
      var t = now - startTime;
      ctx.clearRect(0, 0, w, h);
      ctx.globalAlpha = t > DURATION - 800 ? Math.max(0, (DURATION - t) / 800) : 1;
      pieces.forEach(function (p) {
        p.vy += 0.12 * dpr;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2.5, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        }
        ctx.restore();
      });
      if (t < DURATION) requestAnimationFrame(frame);
      else canvas.remove();
    }
    requestAnimationFrame(frame);
  }

  if (onLoad) {
    var seen = false;
    try {
      seen = sessionStorage.getItem('pny-mintweek-confetti') === '1';
      sessionStorage.setItem('pny-mintweek-confetti', '1');
    } catch (e) {}
    if (!seen) burst(160);
  }

  if (onCart) {
    document.addEventListener('product-ajax:added', function () {
      burst(90, 0.75);
    });
  }
})();
